<template>
  <div class="sidebar" :class="{ collapsed: !sidebarOpen }">
    <div class="sidebar-header">
      <h4 class="mb-0" v-show="sidebarOpen">AZ SMART FARMS,SRLS</h4>
    </div>
    <nav class="sidebar-nav">
      <router-link
        to="/dashboard"
        class="nav-item"
        :class="{ active: currentPage === 'dashboard' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-grid-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
          />
        </svg>
        {{ $t("sidebar.dashboard") }}
      </router-link>
      <router-link
        to="/employees"
        class="nav-item"
        :class="{ active: currentPage === 'employees' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-people-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
          />
          <path
            fill-rule="evenodd"
            d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
          />
          <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
        </svg>
        {{ $t("sidebar.employees") }}
      </router-link>
      <router-link
        to="/timesheets"
        class="nav-item"
        :class="{ active: currentPage === 'timesheets' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-clock-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
          />
        </svg>
        {{ $t("sidebar.timesheets") }}
      </router-link>
      <router-link
        to="/payroll"
        class="nav-item"
        :class="{ active: currentPage === 'payroll' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-currency-euro"
          viewBox="0 0 16 16"
        >
          <path
            d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-3.023 0-4.941 1.676-5.277 4.42H4v.928h1.053v1.265H4v.927z"
          />
        </svg>
        {{ $t("sidebar.payroll") }}
      </router-link>
      <router-link
        to="/advances"
        class="nav-item"
        :class="{ active: currentPage === 'advances' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-wallet2"
          viewBox="0 0 16 16"
        >
          <path
            d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
          />
        </svg>
        {{ $t("sidebar.advances") }}
      </router-link>

      <!-- Language Switcher -->
      <div class="sidebar-language-switcher mt-auto p-3" v-show="sidebarOpen">
        <LanguageSwitcher />
      </div>
    </nav>
  </div>
</template>

<script>
import LanguageSwitcher from "./LanguageSwitcher.vue";

export default {
  name: "AdminSidebar",
  components: {
    LanguageSwitcher,
  },
  props: {
    sidebarOpen: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: String,
      default: "dashboard",
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: white;
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.sidebar.collapsed {
  width: 70px;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
  text-align: center;
}

.sidebar-nav {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.05rem;
  gap: 1rem;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar.collapsed .nav-item {
  padding: 1rem 0.5rem;
  justify-content: center;
  font-size: 0;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-item.active,
.nav-item.router-link-active {
  background-color: rgba(52, 152, 219, 0.2);
  color: #3498db;
  border-left: 4px solid #3498db;
}

.nav-item svg {
  flex-shrink: 0;
}

.sidebar-language-switcher {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar:not(.collapsed) {
    transform: translateX(0);
  }
}
</style>
